"use client";

import { env } from "@repo/env";
import posthog from "posthog-js";
import { PostHogProvider as PostHogProviderRaw } from "posthog-js/react";
import type { ReactNode } from "react";

export const analytics = posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
  api_host: "/ingest",
  ui_host: env.NEXT_PUBLIC_POSTHOG_HOST,
  person_profiles: "identified_only",
  capture_pageview: false,
  capture_pageleave: true,
  defaults: "2026-01-30",
  capture_exceptions: {
    capture_unhandled_errors: true,
    capture_unhandled_rejections: true,
    capture_console_errors: false,
  },
  loaded: (client) => {
    client.register({
      app: "trayn",
      surface: "web-app",
    });
  },
});

export const PostHogProvider = ({
  children,
}: {
  readonly children: ReactNode;
}) => <PostHogProviderRaw client={analytics}>{children}</PostHogProviderRaw>;
